import { useEffect, useRef, useTransition } from 'react';

export function useAsyncStartTransition() {
  const [isPending, startTransition] = useTransition();
  const previousIsPending = useRef<boolean>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const resolveCallbackFunction = useRef<any>(null);
  const rejectCallbackFunction = useRef<
    ((reason: unknown) => PromiseLike<never>) | ((reason?: unknown) => void) | null | undefined
  >(null);

  useEffect(() => {
    if (!isPending && previousIsPending.current && resolveCallbackFunction.current) {
      resolveCallbackFunction.current();
    }

    return () => {
      previousIsPending.current = isPending;
    };
  }, [isPending]);

  async function asyncStartTransition<T>(callback: () => Promise<T>) {
    const result = new Promise<T>(function (resolve, reject) {
      resolveCallbackFunction.current = resolve;
      rejectCallbackFunction.current = reject;
    });

    startTransition(() => {
      callback().catch(rejectCallbackFunction.current);
    });

    await result;
  }

  return asyncStartTransition;
}
